import { createApi } from "@reduxjs/toolkit/query/react";
import { encryptQueryString, transformRequest } from '../../../utils/API/requestMiddleware';
import { transformErrorResponse, transformSucessResponse } from "../../../utils/API/responseMiddleware";
import { defautBaseQuery } from "../../../utils/API/fetchBaseQuery";


const employeesApi = createApi({
    reducerPath: 'employeesApi',
    baseQuery: defautBaseQuery,
    endpoints: (builder) => ({
        getSGBCCorporateEmployeeListById: builder.query({
            query: (id) => ({
                url: encryptQueryString(`/Employee/GetSGBCCorporateEmployeeListById?id=${id}`),
                method: 'GET',
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        addEmployeesByCorporateMemberId: builder.mutation({
            query: (details) => ({
                url: '/Employee/AddSGBCCorporateMemberEmployeesByCorporateMemberId',
                method: 'POST',
                body: transformRequest(details)
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        checkGMAPCertificationByEmail: builder.mutation({
            query: (details) => ({
                url: '/Employee/CheckGMAPCertificationByEmailAddress',
                method: 'POST',
                body: transformRequest(details)
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        updateEmployeesByCorporateEmployeeId: builder.mutation({
            query: (details) => ({
                url: '/Employee/UpdateSGBCCorporateMemberEmployeesByCorporateEmployeeId',
                method: 'POST',
                body: transformRequest(details)
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        getEmployeeDetailsByEmployeeId: builder.query({
            query: (id) => ({
                url: encryptQueryString(`/Employee/GetSGBCCorporateEmployeeDetailsBySGBCCorporateEmployeeId?id=${id}`),
                method: 'GET',
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        deleteCorporateEmployeeById: builder.query( {
            query: ( id ) => ( {
                url: `/Employee/DeleteCorporateEmployeeById?id=${ id }`,
                method: 'POST',
            } ),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        } ),
        deleteCorporateKeyPositionById: builder.query( {
            query: ( id ) => ( {
                url: `/Employee/DeleteCorporateKeyPositionById?id=${ id }`,
                method: 'POST',
            } ),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        } ),
        searchByEmailForKeyPosition: builder.query({
            query: (details) => ({
                url: '/Dashboard/SearchByEmailForKeyPosition',
                method: 'POST',
                body: transformRequest(details)
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
    })
})

export const {
    useLazyGetSGBCCorporateEmployeeListByIdQuery,
    useAddEmployeesByCorporateMemberIdMutation,
    useCheckGMAPCertificationByEmailMutation,
    useUpdateEmployeesByCorporateEmployeeIdMutation,
    useLazyGetEmployeeDetailsByEmployeeIdQuery,
    useLazyDeleteCorporateEmployeeByIdQuery,
    useLazyDeleteCorporateKeyPositionByIdQuery,
    useLazySearchByEmailForKeyPositionQuery
} = employeesApi;

export default employeesApi;